module.exports = __webpack_public_path__ + "img/DSJFX.117bc263.svg";